import { render, staticRenderFns } from "./WindControlHome.vue?vue&type=template&id=310a1000&"
import script from "./WindControlHome.vue?vue&type=script&lang=js&"
export * from "./WindControlHome.vue?vue&type=script&lang=js&"
import style0 from "./WindControlHome.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports